module.exports = __webpack_public_path__ + "img/bg-carousel-container.e66b5b8.png";